import { UserCircleIcon } from "@phosphor-icons/react/dist/csr/UserCircle";
import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { QuickbooksBillStatus, ReviewBadge } from "@/accounts-payable/common";
import type { ApInvoice } from "@/accounts-payable/types";

// The bill follows the review, so its state sits under the review's, as a
// job's confidence sits under the job. A column of its own pushed Total out
export const reviewCol: ColumnDef<ApInvoice> = {
  accessorKey: "review_state",
  header: "Review",
  meta: { size: "130px" },
  cell: ({ row }) => (
    <Stack gap={1} align="start">
      <ReviewBadge document={row.original} />
      <QuickbooksBillStatus
        bill={row.original.quickbooks_bill}
        showLink={false}
      />
      {row.original.assignee && (
        <Stack
          direction="row"
          gap={1}
          align="center"
          className="max-w-full text-sm text-subtle"
        >
          <UserCircleIcon aria-hidden className="h-3.5 w-3.5 flex-none" />
          <span className="truncate" title={row.original.assignee.name}>
            <span className="sr-only">Assigned to </span>
            {row.original.assignee.name}
          </span>
        </Stack>
      )}
    </Stack>
  ),
};
